import PropTypes from 'prop-types';
import classnames from 'classnames';
import { trackAdobeFeature } from '../../utils/trackers/adobe';

export default function ReferenceRange({ labels, currentlyViewedIndex, selectInRange }) {
  if (labels.length < 2) {
    return null;
  }

  const onClick = index => () => {
    trackAdobeFeature('inline-reference');
    selectInRange(index);
  };

  const buttons = labels.map((label, index) => (
    <li key={label}>
      <button
        onClick={onClick(index)}
        className={classnames('ref-list-link', { active: index === currentlyViewedIndex })}
        type="button"
      >
        {label}
      </button>
    </li>
  ));
  return (
    <div className="reference-labels u-padding-xs-top u-padding-s-bottom">
      <ol>{buttons}</ol>
    </div>
  );
}

ReferenceRange.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string),
  currentlyViewedIndex: PropTypes.number,
  selectInRange: PropTypes.func.isRequired,
};

ReferenceRange.defaultProps = {
  labels: [],
  currentlyViewedIndex: 0,
};
